import { type ButtonProps as MuiButtonProps } from '@mui/material/Button';

import type { ButtonProps } from './Button';

export const getVariant = (
  variant: ButtonProps<'button'>['variant']
): {
  variant: MuiButtonProps<'button'>['variant'];
  color?: MuiButtonProps<'button'>['color'];
} => {
  if (!variant) {
    return { variant: 'contained' };
  }

  switch (variant) {
    case 'primary':
      return {
        color: 'primary',
        variant: 'contained',
      };

    case 'secondary':
      return {
        color: 'secondary',
        variant: 'outlined',
      };

    case 'text':
      return {
        variant: 'text',
      };

    case 'destroy':
      return {
        color: 'error',
        variant: 'outlined',
      };

    default:
      return { variant: variant };
  }
};
